import firebase_api from '@/firebase/firebase_api'
const referentiel_Tuto = {
    data : {
        id: null,
        numero: 0,
        byId: null
    },
    searchIndexObject(objectName, demo, tutos) {
        var bool = false;
        var indexTuto = demo.tuto;
        var indexReturn = -1;
        for (var i=indexTuto+1;i<tutos.data.length;i++) {
            if (typeof(tutos.data[i])!="undefined")
                var id = tutos.data[i].id;
                if (!bool) {
                    bool = id == objectName && tutos.data[i].pred == indexTuto;    
                    if (bool)
                        indexReturn = i;
                }
        }
        return indexReturn;
    },
    equipeHasScore(equipe) {
        // return true si le score est renseigné
        // false si le score n'est pas renseigné
            if (equipe != null) {
                var val = parseInt(equipe.score.joueurs);
                if (!isNaN(val))
                    return true;
                else
                    return equipe.score.joueurs != null && equipe.score.joueurs != '';
            }
            else
                return false;
        },
    initScore (idClub, idTournoi, idPartie, fct) {
        var club = firebase_api.api.getDb().collection("club").doc(idClub);
        var tournoi = club.collection("tournois").doc(idTournoi);
        var partie = tournoi.collection("parties").doc("P"+idPartie);
        var equipes = partie.collection("equipes");
        equipes.get().then(equipesDoc=>{
            var docs = equipesDoc.docs;
            for (var indexDoc in docs) {
                var equipeDoc = docs[indexDoc];
                var equipeData = equipeDoc.data();
                if (!this.equipeHasScore(equipeData)) {
                    var win = Math.floor(Math.random() * Math.floor(2));
                    
                    var winEquipe = (win==1) ? "joueurs" : "contre";
                    var loseEquipe = (win==1) ? "contre" : "joueurs";
                    
                    equipeData.score[winEquipe] = 13;
                    equipeData.score[loseEquipe]= Math.floor(Math.random() * Math.floor(13));
                    equipeDoc.ref.update({
                        score: equipeData.score,
                        state: "FINISH"
                    })
                    partie.update({
                        state: "FINISH"
                    })
                }
                if (indexDoc == docs.length-1) {
                    fct();
                } 
            }
        })
    },
    display(objectName, byId, route, demo, tutos, user) {
        var indexTuto = demo.tuto;
        if (tutos!=null) {
            if (typeof(tutos.data[indexTuto])!="undefined") {
            if (route == tutos.data[indexTuto].route) {
                var userTest = typeof(user.test)!="undefined" ? user.test : false;
                if (tutos.record && userTest)
                    return true;
                else {
                    return this.searchIndexObject(objectName, demo, tutos) != -1;
                }
            }
            else 
                return false;
            }
            else 
                return false;
        }
        else
            return false;
    },
    
    
    tuto (objectName, byId, route, demo, tutos, fct) {
        var id;
        var byId = true;
        id = objectName;
      
        
        if (tutos.record) {
            var data = {
                    id: id,
                    byId: byId,
                    route: route,
                    html: "",
                    back: false,
                    inc: 1,
                    returnTo: 1,
                    pred: parseInt(demo.tuto)
            }
            tutos.data.push(data);
            firebase_api.api.getDb().collection("tuto").doc(tutos.id).update({
                data: tutos.data,
                record: false
            })
            fct(-1);
        }
        else {
          
            var indexTuto = this.searchIndexObject(objectName, demo, tutos);
          
            if (indexTuto!=-1) {
              
                if (typeof(tutos.data[indexTuto])!="undefined") {
               
                    var byId = tutos.data[indexTuto].byId;
                    var id = tutos.data[indexTuto].id;
                  
                    
                        if (byId && id == objectName) {
                            var tuto = parseInt(demo.tuto) + parseInt(tutos.data[indexTuto].inc);
                           
                            fct(tuto);
                        }
                        else
                            fct(-1);
                }
                else
                    fct(-1);
            }
            else
                fct(-1);
        }
    }
}

export default {
    object: referentiel_Tuto
}